<template>
  <div class="shareroutine">
        <b-container fluid >
            <b-row class="mycontainer-main " >
                <b-col cols="12" md="4" class="pl-5 leftcontent" >
                    <h6 class="my-0" style="color: grey"> Results </h6>                      
                    <h2> {{ $t('shareroutine.jumbo_title') }} </h2>
                    <br>                                      
                    <h1 style="font-weight: 900; font-size: 1.9em;"> {{ $t('shareroutine.jumbo_desc1') }} </h1>
                    <h1 style="font-weight: 900; font-size: 1.9em;"> {{ $t('shareroutine.jumbo_desc2') }} </h1>
                    <appt-button v-bind:color="'d'"/>   
                </b-col>

                <b-col cols="12" md="7" class="align-self-center py-3r" id="clinicservices">
                    <b-card-group deck>
                        <b-card 
                        v-for="(r,index) in routines" :key="index"
                        img-top  
                        :img-src="require('../assets/images/athome2.jpeg')"                      
                        class="shadow my-2"
                        style="min-width: 20rem; max-width: 20rem;"                     
                        >
                            <template v-slot:header>
                                <h5 style="font-weight: 600; font-size: 1em;" class="mb-0">{{r.skintype}} Skin for {{r.season}}</h5>
                            </template>
                           
                            <b-card-title style="font-weight: bold;">"{{r.title}}"</b-card-title>
                            <b-card-sub-title class="pb-2 text-muted">{{r.author}}</b-card-sub-title>
                            <b-card-text>  {{r.description}}</b-card-text>
                                                     
                              <template v-slot:footer>
                                  <div class="row">
                                      <div class="col">
                                        <b-button squared style="background-color: black;" class=" shadow" to="/clinic/services">View Routine</b-button> 
                                        <small class="text-muted">Verifed
                                            <b-avatar icon="star-fill" variant="info" size="sm"></b-avatar>
                                        </small>  
                                      </div>
                                      <div class="col text-right">                       
                                        <b-button size="sm" variant="primary">                                      
                                            Likes <b-badge variant="light">{{r.likes}}</b-badge>
                                        </b-button> 
                                      </div>
                                </div>                               
                            </template>
                        </b-card>
                    </b-card-group> 
                   
                       
                </b-col>              
           </b-row>

        </b-container>
  </div>
</template>

<script>
export default {
  name: 'shareroutine',
  data () {
    return {
      msg: 'Welcome to BI',
      routines: [ 
          {
          skintype: "Red",
          title:"Best Matis Routine Ever, I Love this",
          author:"Claudia",
          location: "Quebec City",
          img:"retail-clinic.jpg", //from aws s3 link
          description:"I love this routine for my red skin",
          season:"All Seasons",
          products: {
              cleanser:{name: "matis 123", use:"daily in morning"},
              toner:{name: "matis 123", use:"daily in morning"},
              serum:{name: "matis 123", use:"daily in morning"},
              daycream:{name: "matis 123", use:"daily in morning"},
              nightcream:{name: "matis 123", use:"daily in morning"},
              eyecream:{name: "matis 123", use:"daily in morning"},
              exfoliator:{name: "matis 123", use:"daily in morning"},
              mask:{name: "matis 123", use:"daily in morning"},

          },
          howtouse:"I use this routine daily. I apply x to x and get x",
          date: '2017-03-01',         
          verified:true,
          shoplink:"www.moncoachbeaute.ca",
          likes: 107 //must provide email only, this will allow verified and reduce dupicate submissions
          },
                    {
          skintype: "Red",
          title:"Best Matis Routine",
          author:"Claudia",
          location: "Quebec City",
          img:"retail-clinic.jpg", //from aws s3 link
          description:"I love this routine for my red skin",
          season:"All Seasons",
          products: {
              cleanser:{name: "matis 123", use:"daily in morning"},
              toner:{name: "matis 123", use:"daily in morning"},
              serum:{name: "matis 123", use:"daily in morning"},
              daycream:{name: "matis 123", use:"daily in morning"},
              nightcream:{name: "matis 123", use:"daily in morning"},
              eyecream:{name: "matis 123", use:"daily in morning"},
              exfoliator:{name: "matis 123", use:"daily in morning"},
              mask:{name: "matis 123", use:"daily in morning"},

          },
          howtouse:"I use this routine daily. I apply x to x and get x",
          date: '2017-03-01',         
          verified:true,
          shoplink:"www.moncoachbeaute.ca",
          likes: 107 //must provide email only, this will allow verified and reduce dupicate submissions
          },
                    {
          skintype: "Red",
          title:"Best Matis Routine",
          author:"Claudia",
          location: "Quebec City",
          img:"retail-clinic.jpg", //from aws s3 link
          description:"I love this routine for my red skin",
          season:"All Seasons",
          products: {
              cleanser:{name: "matis 123", use:"daily in morning"},
              toner:{name: "matis 123", use:"daily in morning"},
              serum:{name: "matis 123", use:"daily in morning"},
              daycream:{name: "matis 123", use:"daily in morning"},
              nightcream:{name: "matis 123", use:"daily in morning"},
              eyecream:{name: "matis 123", use:"daily in morning"},
              exfoliator:{name: "matis 123", use:"daily in morning"},
              mask:{name: "matis 123", use:"daily in morning"},

          },
          howtouse:"I use this routine daily. I apply x to x and get x",
          date: '2017-03-01',         
          verified:true,
          shoplink:"www.moncoachbeaute.ca",
          likes: 107 //must provide email only, this will allow verified and reduce dupicate submissions
          },
          {
          skintype: "Red",
          title:"Best Matis Routine",
          author:"Claudia",
          location: "Quebec City",
          img:"retail-clinic.jpg", //from aws s3 link
          description:"I love this routine for my red skin",
          season:"All Seasons",
          products: {
              cleanser:{name: "matis 123", use:"daily in morning"},
              toner:{name: "matis 123", use:"daily in morning"},
              serum:{name: "matis 123", use:"daily in morning"},
              daycream:{name: "matis 123", use:"daily in morning"},
              nightcream:{name: "matis 123", use:"daily in morning"},
              eyecream:{name: "matis 123", use:"daily in morning"},
              exfoliator:{name: "matis 123", use:"daily in morning"},
              mask:{name: "matis 123", use:"daily in morning"},

          },
          howtouse:"I use this routine daily. I apply x to x and get x",
          date: '2017-03-01',         
          verified:true,
          shoplink:"www.moncoachbeaute.ca",
          likes: 107 //must provide email only, this will allow verified and reduce dupicate submissions
          }
      ],

    }
  },
  methods: {
    getImg(p) {
        var images = require.context('../assets/images/', false, /\.jpg$/)
        return images('./' + p + ".jpg")
  },
    goBack(){
    this.$router.go(-1)
  }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mycontainer-main {
    min-height:  calc(90vh);
}

.m-borders{
    border: 3px solid white
}
.retail-clinic{
    background-image: linear-gradient(rgba(0, 0, 0, 0.5),
                       rgba(0, 0, 0, 0.3)), url('../assets/images/retail-clinic.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 'contain';
}
.retail-clinic h2{
    color: white;
    font-weight: 400;
}
.main-background{
    background-image:url('../assets/images/waiting_room_front_3.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
h2 {
    font-weight: 400;
}
.brand-bar {
    background-color: lightgray;
}

.bar {
  animation-duration: 3s;
  animation-name: slidein;
  background-color: black;
  height: 25px;
  margin-bottom: 25px;
  margin-left: -25vw;
  margin-right: 25%;
}
.animate-left {
   animation-duration: 3s;
    animation-name: slidein;   
}

@keyframes slidein {
  from {
    margin-right: 100%;
  }

  to {
    margin-right: 25%;

  }
}

.search-container button {
  padding: 6px 10px;
  margin-right: 0px;
  background: #ddd;
  font-size: 17px;
  border: none;
  cursor: pointer;
}
.search-container input[type=text] {
  padding: 6px;
  margin-top: 8px;
  font-size: 17px;
  border: none;
}
.main-button {
    width: 175px;
    text-transform: uppercase;
}

.background-aesthetic{
    background-image: linear-gradient(rgba(0, 0, 0, 0.5),
                       rgba(0, 0, 0, 0.3)), url('../assets/images/aesth1.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.background-consultation{
    background-image: linear-gradient(rgba(0, 0, 0, 0.5),
                       rgba(0, 0, 0, 0.3)), url('../assets/images/formulary.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
#clinicservices .card-columns {
    column-count: 2;
}
@media (max-width: 576px) {
    #clinicservices .card-columns {
        column-count: 1;
    }
}
.leftcontent {
    padding-top: 30vh;
    padding-bottom: 10vh;
}
.card-img-top {
    width: 100%;
    height: 20rem;
    object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/ShareRoutine.vue